import React from "react"
import { Grid, makeStyles } from "@material-ui/core"
import Overview from "./Overview"
import FlashCard from "./FlashCard"

export default function About({ courseDuration, level, data }) {
  const classes = useStyles();

  return (
    <Grid container justify={"space-between"}>
      <Grid item xs={12} md={7}>
        <Overview data={data} />
      </Grid>
      <Grid item xs={12} md={3} className={classes.flashCard}>
        <FlashCard
          courseDuration={courseDuration}
          level={level}
          data={data.sideBar}
        />
      </Grid>
    </Grid>
  )
}

const useStyles = makeStyles(theme => ({
  flashCard: {
    [theme.breakpoints.between("xs", "sm")]: {
      paddingTop: theme.spacing(4),
    },
  },
}))
